module.exports = __webpack_public_path__ + "static/media/playstore.cea2736b.png";